import { render, staticRenderFns } from "./actividades.vue?vue&type=template&id=b21f6520"
import script from "./actividades.vue?vue&type=script&lang=js"
export * from "./actividades.vue?vue&type=script&lang=js"
import style0 from "./actividades.vue?vue&type=style&index=0&id=b21f6520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports